module.exports = "<span>{{ $ctrl.formatAmount() }}</span>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/base/views/money.html
// module id = 291
// module chunks = 0